import React, {useEffect, useState} from "react";
import "./App.css";
import {Layout} from "./components/Layout";
import {useAppDispatch} from "./app/hooks";
import {LoginToken} from "./components/Auth/AuthActions";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import {SemanticToastContainer} from "react-semantic-toasts";

const App = () => {
  const dispatch = useAppDispatch();
  const [dataLoaded, setDataLoaded] = useState(false);
  
  useEffect(() => {
    const cleanupBlobUrls = () => {
      try {
        const oldPersistedState = localStorage.getItem('persist:main');
        if (oldPersistedState) {
          localStorage.removeItem('persist:main');
        }

        // clean up new persist:labelEdit key
        const persistedState = localStorage.getItem('persist:labelEdit');
        if (persistedState) {
          const state = JSON.parse(persistedState);
          if (state.present) {
            const present = JSON.parse(state.present);
            if (present.labelItems && Array.isArray(present.labelItems)) {
              let changed = false;
              present.labelItems = present.labelItems.map((item: any) => {
                if (item?.value && typeof item.value === 'string' && item.value.startsWith('blob:')) {
                  changed = true;
                  return { ...item, value: "" };
                }
                return item;
              });

              if (changed) {
                state.present = JSON.stringify(present);
                localStorage.setItem('persist:labelEdit', JSON.stringify(state));
              }
            }
          }
        }
      } catch (error) {
        console.warn('Failed to clean up blob URLs:', error);
      }
    };
    
    cleanupBlobUrls();
    dispatch(LoginToken()).then(() => setDataLoaded(true));
  }, []);
  
  return (
    <div className="App">
      <SemanticToastContainer position="bottom-right" className="compact-toast-container" maxToasts={1} />
      {dataLoaded && <Layout />}
    </div>
  );
};

export default App;
